import { default as FNS, logIn } from '../api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteCookie, getCookie } from '../cookie';
import { toast } from 'react-toastify';

export const fetchUserAsync = createAsyncThunk('user/fetchUser', async () => {
  try {
    
    if(!getCookie("SESSION")) return null;
    return await FNS.getCurrentUser();
    
  } catch (e) {
    toast.error(e.message);
  }
});

export const logInUserAsync = createAsyncThunk('user/logInUser', async ({ username, password }) => {
  const res = await logIn(username, password);
  await FNS.getCurrentUser();
  document.cookie = `SESSION=${res}; max-age=2592000; path=/`;
  return res;
});

export const createUser = createAsyncThunk('user/create', async ({ firstname, phone, username, email, password, role }) => {
  try {

    const id = await FNS.createUser(username, firstname, phone, email, password, role);
    return id;

  } catch (e) {
    toast.error(e.message);
  }
});

export const updateUser = createAsyncThunk('user/update', async ({ id, username, firstname, phone, email, role }) => {
  try {
    await FNS.updateUser(id, username, firstname, phone, email, role);
    return id;
  } catch (e) {
    toast.error(e.message);
  }
});

export const resetPassword = createAsyncThunk('user/resetPassword', async ({ id, password }) => {
  await FNS.resetPassword(id, password);
});



const userSlice = createSlice({
  name: 'user',
  initialState: {
    authenticated: false,
    data: null,
  },
  reducers: {
    logOut: (state, { payload }) => {
      deleteCookie("SESSION", "/");
      state.authenticated = false;
      state.data = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserAsync.fulfilled, (state, action) => {
        state.data = action.payload;
        state.authenticated = true;
      });
  },
});

export const { logOut } = userSlice.actions;
export default userSlice.reducer;
